import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@/store";
import { fetchCurrentUser } from "@/store/slices/authSlice";

export function CallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCurrentUser()).then(() => {
      setTimeout(() => navigate("/dashboard", { replace: true }), 500);
    });
  }, [dispatch, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography
        sx={{
          color: "text.secondary",
        }}
      >
        {t("auth.signingIn")}
      </Typography>
    </Box>
  );
}
